import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../services/api';
import auth from '../services/auth';
import './AdminDashboard.css';

const AdminDashboard = () => {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        if (!auth.isAuthenticated()) {
            navigate('/admin/login');
            return;
        }
        fetchPosts();
    }, [navigate]);

    const fetchPosts = async () => {
        try {
            const response = await api.getPosts();
            setPosts(response.data);
        } catch (error) {
            setError('Failed to load posts');
            console.error('Error:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleEdit = (slug) => {
        navigate(`/admin/edit/${slug}`);
    };

    const handleDelete = async (slug) => {
        if (window.confirm('Are you sure you want to delete this post?')) {
            try {
                await api.deletePost(slug);
                fetchPosts();
            } catch (error) {
                console.error('Error deleting post:', error);
                alert('Failed to delete post');
            }
        }
    };

    const handleLogout = () => {
        auth.logout();
        navigate('/');
    };

    if (loading) return <div className="admin-container">Loading...</div>;
    if (error) return <div className="admin-container error">{error}</div>;

    return (
        <div className="admin-container">
            <header className="admin-header">
                <h1><Link to="/">Sercihan's</Link></h1>
            </header>
            
            <div className="admin-content">
                <div className="admin-toolbar">
                    <h2>Manage Posts</h2>
                    <div className="admin-actions">
                        <button
                            onClick={() => navigate('/admin/new-post')}
                            className="action-button primary"
                        >
                            New Post
                        </button>
                        <button
                            onClick={() => navigate('/admin/analytics')}
                            className="action-button secondary"
                        >
                            Analytics
                        </button>
                        <button
                            onClick={handleLogout}
                            className="action-button logout"
                        >
                            Logout
                        </button>
                    </div>
                </div>
                
                {posts.length === 0 ? (
                    <div className="no-posts">No posts yet. Create your first post!</div>
                ) : (
                    <div className="posts-table">
                        {posts.map(post => (
                            <div key={post.id} className="post-row">
                                <div className="post-main">
                                    <div className="post-title">{post.title}</div>
                                    <div className="post-meta">
                                        <span className="post-date">
                                            {new Date(post.created_at).toLocaleDateString('en-US', {
                                                year: 'numeric',
                                                month: 'short',
                                                day: 'numeric'
                                            })}
                                        </span>
                                        <span className={`post-status ${post.is_published ? 'published' : 'draft'}`}>
                                            {post.is_published ? 'Published' : 'Draft'}
                                        </span>
                                    </div>
                                </div>
                                <div className="post-actions">
                                    <button
                                        onClick={() => handleEdit(post.slug)}
                                        className="edit-button"
                                    >
                                        Edit
                                    </button>
                                    <button
                                        onClick={() => handleDelete(post.slug)}
                                        className="delete-button"
                                    >
                                        Delete
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default AdminDashboard;
